import axios from 'axios';

import { handleOdinApi, handleApi } from '../common';
import STRINGS from '../../strings';

const API_ENDPOINTS = {
	orderBook: '/api/equity/api/eqm/orders/order_book/get',
	sip: '/api/equity/api/eqm/orders/order_book/sip/get',
	tradebook: '/api/equity/api/eqm/orders/order_book/trades/get',
};

const ODIN_API_ENDPOINTS = {
	cancelAllOrders: '/transactional/v1/cancelorders',
	cancelOrder: (exchange, order_id) =>
		`/transactional/v1/orders/regular/${exchange}/${order_id}`,
	cancelorders: '/transactional/v1/cancelorders',
	modifySip: (
		sip_id,
		status,
		symbol,
		transaction_type,
		investment_type,
		qtyOrVal,
	) =>
		`/transactional/v1/orders/eqsip/${sip_id}/${status}/${symbol}/${transaction_type}/${investment_type}/${qtyOrVal}`,
	sipTransactions: (sipId) => `/transactional/v1/eqsipOrderDetails/${sipId}`,
};

export const fetch_order_book = async (Api, params = {}) => {
	const url = API_ENDPOINTS.orderBook;
	const data = await Api.get(url, params, {});
	return handleApi(data);
};

export const fetch_single_order_details = async (Api, order_id) => {
	const url = `${API_ENDPOINTS.orderBook}?order_id=${order_id}`;
	const data = await Api.get(url, {}, {});
	return handleApi(data);
};

export const fetch_all_sip_orders = async (Api, params = {}, token = '') => {
	const url = API_ENDPOINTS.sip;
	const result = await Api.get(url, params, {}, token);
	if (axios.isCancel(result)) {
		throw STRINGS.COMMON.ApiCancelled;
	}
	return handleApi(result);
};

export const modify_equity_sip = async (OdinApi, body, token) => {
	const {
		invested_quantity,
		frequency_type,
		sip_id,
		status,
		symbol,
		transaction_type,
	} = body;
	const response = await OdinApi.put(
		ODIN_API_ENDPOINTS.modifySip(
			sip_id,
			status,
			symbol,
			transaction_type,
			frequency_type,
			invested_quantity,
		),
		{},
		{},
		token,
	);
	const result = handleOdinApi(response);
	return result;
};

export const cancel_all_orders = async (OdinApi, params = {}) => {
	const data = await OdinApi.post(
		ODIN_API_ENDPOINTS.cancelorders,
		params,
		{},
	);
	return handleOdinApi(data);
};

export const fetch_sip_transactions = async (OdinApi, sipId, token) => {
	const response = await OdinApi.get(
		ODIN_API_ENDPOINTS.sipTransactions(sipId),
		{},
		{},
		token,
	);
	const result = handleOdinApi(response);
	return result;
};

export const cancel_order = async (OdinApi, exchange, order_id, params = {}) => {
	const url = ODIN_API_ENDPOINTS.cancelOrder(exchange, order_id);
	const data = await OdinApi.delete(url, params, {});
	return handleOdinApi(data);
};

export const fetch_trade_book = async (Api, orderId) => {
	const url = API_ENDPOINTS.tradebook;
	const params = {
		order_ids: [orderId],
	};
	const data = await Api.post(url, params);
	return handleApi(data);
};
